import { render, staticRenderFns } from "./msvGroupList.vue?vue&type=template&id=fd310006&scoped=true"
import script from "./msvGroupList.vue?vue&type=script&lang=js"
export * from "./msvGroupList.vue?vue&type=script&lang=js"
import style0 from "./msvGroupList.vue?vue&type=style&index=0&id=fd310006&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd310006",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd310006')) {
      api.createRecord('fd310006', component.options)
    } else {
      api.reload('fd310006', component.options)
    }
    module.hot.accept("./msvGroupList.vue?vue&type=template&id=fd310006&scoped=true", function () {
      api.rerender('fd310006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/msvGroupList.vue"
export default component.exports